

































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

const MIN_SEARCH_LENGTH = 3

interface ItemBusca {
  id: string
  nome: string
}

@Component
export default class ComponentModalBuscaSelecao extends Vue {
  @Prop({ default: false }) visible!: boolean
  @Prop({ default: 'Adicionar' }) titulo!: string
  @Prop({ default: 'Adicionar' }) textoConfirmar!: string
  @Prop({ default: () => [] }) items!: ItemBusca[]
  @Prop({ default: () => [] }) selecionados!: ItemBusca[]
  @Prop({ default: false }) loadingBusca!: boolean
  @Prop({ default: false }) loadingConfirmar!: boolean

  searchNome: string = ''
  searchCpf: string = ''
  jaPesquisou: boolean = false

  get canSearch(): boolean {
    const nome = (this.searchNome || '').trim()
    const cpf = (this.searchCpf || '').trim()

    const nomeValido = nome.length === 0 || nome.length >= MIN_SEARCH_LENGTH
    const cpfValido = cpf.length === 0 || cpf.length >= MIN_SEARCH_LENGTH
    const temFiltro = nome.length >= MIN_SEARCH_LENGTH || cpf.length >= MIN_SEARCH_LENGTH

    return nomeValido && cpfValido && temFiltro
  }

  get mensagemResultados(): string {
    if (this.jaPesquisou) {
      return 'Nenhum resultado encontrado para a busca.'
    }

    return 'Pesquise por nome e/ou CPF para listar os resultados.'
  }

  get contador(): string {
    if (!this.selecionados.length) {
      return ''
    }

    return `(${this.selecionados.length})`
  }

  @Watch('visible')
  onToggleModal(isOpen: boolean) {
    if (isOpen) {
      this.searchNome = ''
      this.searchCpf = ''
      this.jaPesquisou = false
    }
  }

  isSelecionado(item: ItemBusca): boolean {
    return this.selecionados.some((selecionado: ItemBusca) => selecionado.id === item.id)
  }

  iconeAcao(item: ItemBusca): string {
    return this.isSelecionado(item) ? 'mdi-check' : 'mdi-plus'
  }

  corAcao(item: ItemBusca): string {
    return this.isSelecionado(item) ? 'success' : 'primary'
  }

  emitBusca() {
    if (!this.canSearch) {
      return
    }

    this.jaPesquisou = true
    this.$emit('busca', {
      nome: (this.searchNome || '').trim() || undefined,
      cpf: (this.searchCpf || '').trim() || undefined,
    })
  }

  emitToggle(item: ItemBusca) {
    this.$emit('toggle', item)
  }

  emitConfirmar() {
    this.$emit('confirmar')
  }

  emitClose() {
    this.$emit('close')
  }

  onDialogInput(value: boolean) {
    if (!value) {
      this.emitClose()
    }
  }
}
